import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  message: string
}

const EmptyTableMessageComponent = ({ message }: Props) => {
  return (
    <div css={tw`flex h-full w-full items-center justify-center p-6`}>
      <Typography variant="body1" css={tw`text-shades-700`}>
        {message}
      </Typography>
    </div>
  )
}

export const EmptyTableMessage = memo(EmptyTableMessageComponent)
